import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { ImagePipe } from './pipes/image.pipe';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ImageSizePipe } from './pipes/image-size.pipe';
import { ImageWidthPipe } from './pipes/image-width.pipe';
import { PlatformModule } from '@angular/cdk/platform';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withFetch()),
    ImagePipe,
    ImageSizePipe,
    ImageWidthPipe,
    provideAnimations(),
    PlatformModule,
  ],
};
